import React, { useState, useEffect } from "react";
import IProcessedItemsDetailsDTO from "../../../models/DTO/IProcessedItemDetailsDTO";
import IProcessedItemsDetails from "../../../models/IProcessedItemsDetails";
import UIService from "../../../services/UIService";
import OwLabel from "../OwLabel/OwLabel";
import * as _ from "lodash-es";

type Props = {
    details: IProcessedItemsDetails | IProcessedItemsDetailsDTO | null;
    dismissProcessedDetails: () => void;
    visibleOverride?: boolean;
};

const OwProcessedItemsDetails: React.FC<Props> = ({ details, dismissProcessedDetails, visibleOverride }) => {
    const [visible, setVisible] = useState(visibleOverride || false);

    useEffect(() => {
        if (details !== null && !visible) {
            setVisible(true);
        }
    }, [details, visible]);

    const dismiss = () => {
        setVisible(false);
        dismissProcessedDetails();
    };

    if (!visible || !details) {
        return null;
    }

    let className = "text-white bg-dark";
    let tableClassName = "table-dark bg-dark text-white";

    if (UIService.isMainViewLight()) {
        className = "";
        tableClassName = "";
    }

    return (
        <div className="OwProcessedItemsDetails">
            <div className={`card ${className}`}>
                <div className="card-body">
                    <div>
                        <div className="pointer text-primary" onClick={dismiss}>
                            [ <i className="fa fa-times" /> ] <OwLabel className="pointer" title="dismiss" />
                        </div>
                    </div>
                    <div>
                        <div>
                            <OwLabel title="total_processed" postText=":" className="me-1" />
                            {details.totalProcessed}
                        </div>
                        <div>
                            <OwLabel title="total_created" postText=":" className="me-1" />
                            {details.totalCreated}
                        </div>
                        <div>
                            <OwLabel title="total_updated" postText=":" className="me-1" />
                            {details.totalUpdated}
                        </div>
                        <div>
                            <OwLabel title="total_errored" postText=":" className="me-1" />
                            {details.totalErrored}
                        </div>
                        {details.totalErrored ? (
                            <table className={`table ${tableClassName}`}>
                                <tbody>
                                    {details.errorDetails.map((detail, index) => {
                                        let error = detail.error;

                                        if (_.isObject(error)) {
                                            error = JSON.stringify(error);
                                        }

                                        return (
                                            <tr key={index}>
                                                <th>{detail.item}</th>
                                                <td>{error}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OwProcessedItemsDetails;
